// extracted by mini-css-extract-plugin
module.exports = {"priceMovementChartRoot":"vMg94tnM"};